const columnDataGridHistoryDetails = [
  {
    dataField: 'attrbNumId',
    caption: 'Id',
    notVisible: true,
    dataType: 'number',
    width: 60
  },
  {
    dataField: 'attrbCode',
    caption: 'Наименование',
    notVisible: false,
    dataType: 'text',
    width: 160
  },
  {
    dataField: 'attrbValue',
    caption: 'Значение',
    notVisible: false,
    dataType: 'text',
    width: 120
  },
  {
    dataField: 'attrbValueOld',
    caption: 'Прежнее значение',
    notVisible: false,
    dataType: 'text',
    width: 120
  }
];
export default columnDataGridHistoryDetails;
